import http from "@/axiosConfig";
import toast from "@/global/ToastConfig";


const liquidationRoutes = {
    LIST_BY_LIQUIDATION_TYPE: "dashboard/billing/liquidation/listByLiquidationType",
    LIST_LIQUIDATION: "dashboard/billing/liquidation/list-by-company",
};

export default {
    listByLiquidationType(liquidationType, companyId) {
        return new Promise(resolve => {
            let newData = [];
            http.get(liquidationRoutes.LIST_BY_LIQUIDATION_TYPE,
                {params: {liquidationType, companyId}}
            ).then(({data}) => {
                const code = data.code;
                if (code === 0) {
                    toast.info("No se encontraron liquidaciones ");
                    return;
                }
                if (code < 0) {
                    toast.error("Error al consultar las liquidaciones");
                    return;
                }
                newData = data.info;
            }).catch(() => toast.error("Error al consultar las liquidaciones"))
                .finally(() => resolve(newData));
        });
    },
    liquidationList(companyId) {
        let newInfo = [];
        return new Promise(resolve => {
            http.get(liquidationRoutes.LIST_LIQUIDATION,
                {params: {companyId}}
            ).then(({data}) => {
                const code = data.code;
                if (code === 0) {
                    toast.info("No se encontraron liquidaciones ");
                    return;
                }
                if (code < 0) {
                    toast.error("Error al consultar las liquidaciones");
                    return;
                }
                const liquidationList = data.info;
                this.processLiquidation(liquidationList);
                newInfo = liquidationList;
            }).catch(() => toast.error("Error al consultar las liquidaciones"))
                .finally(() => resolve(newInfo));
        });
    },
    processLiquidation(tariffs){
        tariffs.forEach( tariff => {
            tariff.id = tariff.code;
            tariff.label = tariff.title;
        });
    },

};